/** Origin the Zoom Scheduler embed is served from — validate `postMessage` events against this. */
export const ZOOM_ORIGIN = 'https://scheduler.zoom.us';

/**
 * Zoom scheduler prefill query-param names. CONFIRM against the live Zoom page and adjust here —
 * isolated so the mapping is trivial to change without touching the redirect logic.
 */
// Zoom Scheduler prefill params match the booking-form field names, lowercased with spaces removed
// (per Zoom KB0084432): first/last name are separate `firstname`/`lastname`, NOT a combined `name`.
export const ZOOM_PREFILL_PARAMS = {
  email: 'email',
  firstName: 'firstname',
  lastName: 'lastname',
  // Assumes the booking form labels the field "Phone". If it is "Phone Number" the key is
  // `phonenumber` — verify on the sandbox iframe. An unknown param is ignored by Zoom, so a
  // wrong key costs the prefill only, it does not break booking.
  phone: 'phone',
} as const;

/**
 * NourishedRx brand styling for the embedded Zoom scheduler, passed as Zoom's `embedStyle` param
 * (URL-encoded JSON). White background blends into the white surface card the iframe sits in on
 * the cream page; forest ink text; coral primary button — matching the app's own CTAs. Font is
 * left as Zoom's default (our display faces aren't in Zoom's font list).
 */
export const ZOOM_EMBED_STYLE = {
  backgroundColor: '#ffffff', // --color-surface
  textColor: '#01261f', // --ink (forest)
  buttonColor: '#c9382f', // --color-action-primary
} as const;
